import {doPost} from "./ApiService";

export const BASE_URL = process.env.REACT_APP_API_LOGIN || '/api';

export const signin = (data) => {
  return doPost(`${BASE_URL}/auth`, data)
};

export const refreshToken = (data) => {
  return doPost(`${BASE_URL}/auth/refresh-token`, data)
};
export const newToken = (data) => {
  return doPost(`${BASE_URL}/auth/new-token`, data)
};

export const signup = (data) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve({ userId: "1", Name: "Rosy", email: "ui-lib@gmail.com", age: 25 });
    }, 1000);
  });
};

export const signout = () => {
  // console.log("Log out successfule");
  return new Promise((resolve, reject) => {
    setTimeout(() => resolve(true), 1000);
  });
};

export const getAuthStatus = () => true;
